import { createSlice } from "@reduxjs/toolkit";
import axios from 'utils/axios';
import { FollowUpProps } from "types/FollowUp";
import { store,dispatch} from 'store';

const initialState: FollowUpProps = {
  apiEndPoint: "follow-up",
    isOpen: false,
    open: false,
    list: [],
    last_page:1,
    current_page:1,
    pageNumber:1,
    pageLimit:5,
    error: null,
    item:null,
    alertPopup: false,
    isLoading:false
  };
const followUp = createSlice({
    name: 'follow-up',
    initialState,
    reducers: {
     
      openToggle(state, action) {
        state.isOpen = action.payload.isOpen;
    },
      hasError(state, action) {
        state.error = action.payload.error;
      },
  
      // get all project list
      getLists(state, action) {
        state.list = action.payload;
        state.isLoading=false;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get project details
      
      setSingleList(state, action) {
        state.item = action.payload;     
        state.isLoading=false;  
      },
  
      // GET FollowUps
    getFollowUpsSuccess(state, action) {
        state.list = action.payload.data;
        state.current_page=action.payload.current_page;
        state.last_page=action.payload.last_page;
        state.total=action.payload.total;
        state.isLoading=false;
    },

    // ADD FollowUp
    addFollowUpSuccess(state, action) {
      state.list = [...state.list,action.payload];      
      state.isLoading=false;
    },

    // EDIT FollowUp
    editFollowUpSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
      state.item = action.payload;
      state.isLoading=false;
    },
    //DELETE FollowUp
    deleteFollowUpSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
      state.isLoading=false;
  },
  setApiEndPoint(state, action) {
    state.apiEndPoint = action.payload;
  },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertPopup;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
  },

    }
  });

  export default followUp.reducer;
  export const {  getLists,setPageNumber,setPageLimit,setSingleList,alertPopupToggle,openToggle,setApiEndPoint} = followUp.actions;
  function getApiEndPoint(){
    return store.getState().followUp.apiEndPoint
}
  export function getFollowUps(params:any={}) {
    return async () => {
      dispatch(followUp.actions.setLoading(true));
      try {
        const response = await axios.get(getApiEndPoint(),{params:params});
        dispatch(followUp.actions.getFollowUpsSuccess(response.data));
      } catch (error) {
        dispatch(followUp.actions.hasError(error));
      }
    };
  }

  export function getFollowUp(id: number | undefined) {
    return async () => {
      dispatch(followUp.actions.setLoading(true));
      try {
        const response = await axios.get(getApiEndPoint()+'/'+id);
        dispatch(followUp.actions.setSingleList(response.data));
        // console.log(response.data);
        
      } catch (error) {
        dispatch(followUp.actions.hasError(error));
      }
    };
   
  }

  export function addFollowUp(followUpElement:any) {
    return async () => {
      try {
        console.log(axios.defaults.baseURL);
      
        const response = await axios.post(getApiEndPoint(), followUpElement);
        dispatch(followUp.actions.addFollowUpSuccess(response.data));
      } catch (error) {
        dispatch(followUp.actions.hasError(error));
      }
    };
  }
  
  export function editFollowUp(id: number | undefined,followUpElement: any) {
    return async () => {
      dispatch(followUp.actions.setLoading(true));
      try {
        const response = await axios.put(getApiEndPoint()+'/'+id, followUpElement);
        dispatch(followUp.actions.editFollowUpSuccess(response.data));
      } catch (error) {
        dispatch(followUp.actions.hasError(error));
      }
    };
  }
  export function deleteFollowUp(id: number | undefined) {
    return async () => {
      dispatch(followUp.actions.setLoading(true));
      try {
        await axios.delete(getApiEndPoint()+'/'+id);
        dispatch(followUp.actions.deleteFollowUpSuccess(id));
      } catch (error) {
        dispatch(followUp.actions.hasError(error));
      }
    };
  }